import React from "react";
import "./LoadingSpinner.scss"

interface LoadingSpinnerProps {
  text?: string;
  style?: React.CSSProperties;
  className?: string;
  size?: string;
  width?: string;
  color?: string;
}

const LoadingSpinner = ({ text, style, className, size, width, color }: LoadingSpinnerProps) => {
  const textStyle = {
    ...(color && { color: color }),
  }
  const spinnerStyle = {
    ...(size && { height: size, width: size }),
    ...(width && { borderTopWidth: width, borderLeftWidth: width, borderRightWidth: width }),
    ...(color && { borderTopColor: color, borderLeftColor: color, borderRightColor: color }),
  }

  return (
      <div className={`luna-loading ${ className }`} style={ style }>
        <div className="luna-loading__spinner" style={ spinnerStyle }></div>
        { text && <div className="luna-loading__text" style={ textStyle }>{ text }</div>}
      </div>
    )
};

export default LoadingSpinner
